export default __webpack_public_path__ + "static/media/notify.d34ba6f3.mp3";